import { useCallback, useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useRespondentTargetApi } from 'src/api/useRespondentTargetApi';
import { RespondentTargetEntity } from '../store/enqueteAnswerSlice';

export const useEnqueteAnswerRedirect = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [params] = useSearchParams();
  const respondentRequestId = params.get('id');

  const navigate = useNavigate();
  const { getById } = useRespondentTargetApi();

  const navigateToInput = useCallback(async () => {
    if (!respondentRequestId) return;
    setIsLoading(true);
    const respondentTargets: RespondentTargetEntity[] | null = await getById(respondentRequestId);
    if (respondentTargets && respondentTargets.length === 1) {
      setIsLoading(false);
      return navigate(`/general/enquete-answer/input/${respondentTargets[0].id}`);
    }
    setIsLoading(false);
  }, [respondentRequestId, getById, navigate]);

  useEffect(() => {
    navigateToInput();
  }, [navigateToInput]);

  return { isLoading };
};
